import React from 'react';
import { SvgIcon, useTheme } from '@mui/material';

export default function DataIcon(props) {
  const theme = useTheme();

  return (
    <SvgIcon inheritViewBox {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="24"
        viewBox="0 0 20 24"
        fill="none"
      >
        <path
          d="M13 22.9998L2.92857 22.9998C1.86143 22.9998 1 22.1064 1 20.9998L1 5.00038C1 3.89371 1.86143 3.00038 2.92857 3.00038L17.0714 3.00038C18.1386 3.00038 19 3.89371 19 5.00038L19 18.0004M13 22.9998L14 22.9998L19 19.9998L19 18.0004M13 22.9998L13 19.5004C13 18.672 13.6716 18.0004 14.5 18.0004L19 18.0004"
          stroke={theme.palette.main.professional_blue}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 11.0005H9"
          stroke={theme.palette.main.professional_blue}
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M5 14.0005H13.9999"
          stroke={theme.palette.main.professional_blue}
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M6 1.00049L5.99997 5.00042"
          stroke={theme.palette.main.professional_blue}
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M14 1.00049L14 5.00042"
          stroke={theme.palette.main.professional_blue}
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </SvgIcon>
  );
}
